import Api from '@/services/api.js';

export default {
  addDriver(details) {
    return Api.post('drivers/', details);
  },
  getDrivers(id) {
    if (!!id) {
      return this.getDriverByContractor(id)
    } else {
      return this.getAllDrivers()
    }
  },

  getAllDrivers() {
    return Api.get('drivers/');
  },
  deleteDriver(driver) {
    return Api.delete(`drivers/${driver}`);
  },
  updateDriver(driver) {
    var driverId = driver.id;
    return Api.put(`drivers/${driverId}`, driver);
  },
  getDriversByContractor(contractor) {
    return Api.get('drivers/byContractor/' + contractor);
  },
}